import React from 'react';

interface RouteIconProps {
  className?: string;
}

export const RouteIcon: React.FC<RouteIconProps> = ({
  className = 'w-[15px] h-[10px]',
}) => (
  <svg
    className={className}
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="#6A6A6D"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.56986 1.16988C6.55833 0.178398 8.1625 0.178398 9.15098 1.16988L14.9279 6.96199L13.0929 8.80263C12.1044 9.79412 10.5002 9.79412 9.51173 8.80263L5.53137 4.81015C5.46163 4.7402 5.38707 4.67506 5.31011 4.61475C4.98062 4.32768 4.61024 4.09127 4.20379 3.9224C3.85024 3.77525 3.48468 3.68116 3.10949 3.63774L5.56986 1.16988Z"
      fill="#6A6A6D"
    />
    <path
      d="M0.290756 8.65507C0.420629 8.96386 0.608223 9.24369 0.843918 9.4801L4.42263 5.89049C4.18694 5.65167 3.90795 5.4635 3.60011 5.33565C3.29466 5.20779 2.96517 5.14025 2.63087 5.14025C2.29657 5.14025 1.96708 5.20538 1.65923 5.33323C1.35138 5.45868 1.0724 5.64684 0.836703 5.88326C0.603413 6.11967 0.415819 6.3995 0.288351 6.70829C0.160884 7.01707 0.0959473 7.34757 0.0959473 7.68289C0.0959473 8.01821 0.163289 8.3487 0.290756 8.65507Z"
      fill="#6A6A6D"
    />
  </svg>
);
